<template>
  <img v-if="showPixel" style="display: none" :src="src" />
</template>

<script lang="ts" setup>
const config = useRuntimeConfig()

const showPixel = computed(() =>
  config.public.environment.includes('production'),
)

const src = computed(
  () =>
    `https://tiles.mapz.com/mapproxy/v1/${config.public.mapzApiKey}/beacon.gif`,
)
</script>
